import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchObservationFormInstance } from "../usePatchObservationFormInstance/usePatchObservationFormInstance";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";

interface Props {
	formInstanceId: number;
}

const useSubmitGrading = ({ formInstanceId }: Props) => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		queryClient.invalidateQueries(["user-report"]);
		queryClient.invalidateQueries(["formInstance", formInstanceId]);
		queryClient.invalidateQueries(["month-summary"]);

		toast.success(<CustomToast type="Success" message="Grading Submitted" />, {
			hideProgressBar: true
		});
	};

	const onError = () => {
		toast.error(
			<CustomToast
				type="Error"
				message="Failed to submit grading. please try again."
			/>,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(patchObservationFormInstance, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useSubmitGrading;
